export const PERSON_SEARCH_ENABLE = 'PERSON_SEARCH_ENABLE';
export const personSearchEnable = data => {
  return {
    type: PERSON_SEARCH_ENABLE,
    data
  };
};

export const CHANGE_FORM_STATE = 'PERSON_SEARCH_CHANGE_FORM_STATE'; 
export const changeFormState = data => {
  return {
    type: CHANGE_FORM_STATE,
    state: data
  };
};

export const START_SENDING = 'PERSON_SEARCH_START_SENDING'; 
export const startSending = () => {
  return {
    type: START_SENDING
  };
};

export const SEARCH_API = '/backend/public/v1/search';
export function search(text) {
  return function (dispatch) {
    if (!text) {
      return dispatch(setResponse({'type': 'FeatureCollection', 'features': []}));
    }

    dispatch(startSending());

    const myRequest = new Request(SEARCH_API + '/' + text, {method: 'GET',  headers: {"Content-Type": "application/json"}});

    return fetch(myRequest)
      .then((response) => {

          if (response.ok) {
            response.json().then((response) => {
              dispatch(setResponse(response));
              
              return dispatch(changeFormState('finished'));
            });
          }

          return dispatch(changeFormState('failed'));
        }
      );
  };
}

export const SET_RESPONSE = 'PERSON_SEARCH_SET_RESPONSE'; 
export const setResponse = data => {
  return {
    type: SET_RESPONSE,
    data
  };
};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/personSearch/actions.js